import { useMutation, useQueryClient } from "react-query";

import Video from "../../services/Video";

import { QUERY_KEY } from "./useListVideos";

function useCreateVideo(onSuccess?: (video: Video) => void) {
  const queryClient = useQueryClient();

  return useMutation(Video.createVideo, {
    onSuccess: (video) => {
      queryClient.invalidateQueries(QUERY_KEY);
      onSuccess?.(video);
    },
  });
}

export default useCreateVideo;
